import { render, staticRenderFns } from "./HandCheckPaper.vue?vue&type=template&id=4872b498&scoped=true"
import script from "./HandCheckPaper.vue?vue&type=script&lang=js"
export * from "./HandCheckPaper.vue?vue&type=script&lang=js"
import style0 from "./HandCheckPaper.vue?vue&type=style&index=0&id=4872b498&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872b498",
  null
  
)

export default component.exports